import * as THREE from 'three';
import { Entities } from './entities.js';
import { CFG } from './config.js';

/**
 * The World is the single shared context handed to every system.
 * Systems publish their public API onto it during init(); nothing else is global.
 */
export class World {
  constructor(engine) {
    this.engine = engine;
    engine.world = this;
    this.THREE = THREE;
    this.renderer = engine.renderer;
    this.scene = engine.scene;
    this.camera = engine.camera;
    this.bus = engine.bus;
    this.rng = engine.rng;
    this.time = engine.time;
    this.cfg = CFG;
    this.perf = engine.perf;

    this.entities = new Entities(2600, CFG.world.half);
    this.playerId = -1;

    // Subsystem slots — filled in by each system's init().
    this.input = null;      // { move:{x,y}, look:{x,y}, buttons, pressed(), held(), released() }
    this.terrain = null;    // { heightAt(x,z), normalAt(x,z,out), slopeAt(x,z), materialAt(x,z), group }
    this.sky = null;        // { setTimeOfDay(t), sunDir:Vector3, group }
    this.lighting = null;   // { sun, ambient, csm, setMood(name) }
    this.pipeline = null;   // { render(), setSize(), setBloom(), grade(name), impulse() }
    this.chars = null;      // { player, grunt, officer, ... } render assets
    this.anim = null;       // { clips, vat, play(id, clip), sample() }
    this.crowd = null;      // { sync(), setMax(), visible }
    this.combat = null;     // { strike(desc), damage(id, amount, src) , hitboxes }
    this.impact = null;     // { hit(kind, pos, dir, power) }
    this.ai = null;         // { }
    this.director = null;   // { spawnWave(), pressure() }
    this.vfx = null;        // { slash(), spark(), dust(), ring(), trail(), decal() }
    this.camrig = null;     // { shake(a,f,d), focus(pos), setMode(), kickback() }
    this.audio = null;      // { play(name, opts), music(state), bus }
    this.ui = null;         // { toast(), damage(), setState() }
    this.mission = null;    // { bases, objectives, state, morale }
    this.player = null;     // { id, hp, musou, combo, moveset, ... }
    this.props = null;      // { group }
    this.fx = {};           // scratch namespace for cross-system handles

    this.flags = { paused: false, debugDraw: false, freeCam: false, godMode: false };
    this.scratch = { v3a: new THREE.Vector3(), v3b: new THREE.Vector3(), v3c: new THREE.Vector3(),
                     q: new THREE.Quaternion(), m4: new THREE.Matrix4(), ids: new Int32Array(1024) };
  }
  get e() { return this.entities; }
}
